import { BASE_URL } from "@/constants/endpoints";
import { MobileUser } from "@/pages/users/schema/users.schema";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryString } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let usersApiPromise: Promise<AxiosInstance> | null = null;

const getUsersApi = async (): Promise<AxiosInstance | null> => {
  if (usersApiPromise) return usersApiPromise;
  usersApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return usersApiPromise;
};

export interface GetMobileUsersProps {
  Nombre?: string;
  Apellido?: string;
  Email?: string;
  CUIT?: string;
  Documento?: string;
  Telefono?: string;
  "P.Pagina"?: number;
  "P.Records"?: number;
}

export interface GetMobileUsersResponse {
  listado: MobileUser[];
  totalPages: number;
  totalRecords: number;
}

export const getMobileUsers = async (
  props: GetMobileUsersProps,
): Promise<GetMobileUsersResponse | null> => {
  const api = await getUsersApi();
  if (!api) return null;

  const response = await api.get(
    `/Usuario/GetListadoUsuariosMobileQuery?${objectToQueryString(props)}`,
  );

  return response.data;
};

interface UpdateUserMobileProps {
  IdUsuario: number;
}

export const updateUserMobile = async (props: UpdateUserMobileProps) => {
  const api = await getUsersApi();
  if (!api) return null;

  const response = await api.put(
    `/Usuario/PutValidaIdentidad?${objectToQueryString(props)}`,
  );

  return response;
};

export interface GetUsuariosByCuentaProps {
  cuenta: string;
}

export const getUsuariosMobileByCuenta = async (
  props: GetUsuariosByCuentaProps,
) => {
  const api = await getUsersApi();
  if (!api) return null;

  const response = await api.get(
    `/Usuario/GetUsuariosByCuenta?${objectToQueryString(props)}`,
  );

  return response.data;
};
